import { UpdateEscrowSettingsApiRow, UpdateEscrowSettingsRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

// Used by the Flatfile/CSV upload flow — still accepts the flat tax fields.
export const validateUpdateEscrowSettings = makeValidator({
  FieldParser: UpdateEscrowSettingsRow,
});

// Used by the public REST API — rejects flat tax fields in favor of the nested address*Tax shape.
export const validateUpdateEscrowSettingsApi = makeValidator({
  FieldParser: UpdateEscrowSettingsApiRow,
});
